//import React from "react";
import { useContext } from 'react';
import { AuthContext } from '../../shared/context/auth-context';

const Stripe = () => {
    const auth = useContext(AuthContext);
    console.log(auth)
    let clientReferenceId;
    
    if (auth.isInOrganization) {
        clientReferenceId = auth.memberships?.[0]?.orgId || null;
    } else {
        clientReferenceId = "admin"
    }
    console.log("Stripe clientReferenceId: ", clientReferenceId);
    return (
		{/*<div style={{
                padding: '20px',
                textAlign: 'center',
                position: 'relative',
                }}>
			<stripe-pricing-table
				//pricing-table-id="prctbl_1RVvaOBed6SuDIiaoS0Frekr"
				//publishable-key="pk_live_51QiKLNBed6SuDIiaC1F9DxH83WcBDL19kSMS2vqxcevPR7WQSUDHXsNjDjk60E2l5ye6QaC3L1x7pPSrZpxH2NZq00gRhugayx"
                pricing-table-id="prctbl_1RWIpSBed6SuDIiaGtN3lJwa"
                publishable-key="pk_test_51QiKLNBed6SuDIiaVbUaAOozTkIST0Plo0vI7sL5BO1kHaXVQiV3IfyalFH73J8rqCMQTHXU3h6I4h0eBqAEdsEO00euUDOjJj"
                client-reference-id={clientReferenceId}
            ></stripe-pricing-table>
		</div>*/}
	);
};

export default Stripe;
